export default class ViewerTabHelper {
    constructor(element) {
        const self = this;

        element.addEventListener('wheel', this._mouseWheelEventHandler.bind(this), false);

        this._tabList = element.querySelectorAll('[role="tab"]');

        this._tabPanelList = new Array();
        Array.prototype.forEach.call(this._tabList, function (tab) {
            tab.addEventListener('click', self._changeTab.bind(self), false);
            tab.addEventListener('mouseover', self._mouseOverEvent.bind(self), false);
            tab.addEventListener('mouseout', self._mouseOutEvent.bind(self), false);

            const tabPanel = document.getElementById(tab.getAttribute('aria-controls'));
            self._tabPanelList.push(tabPanel);
        });

        this._dragFlag = false;
    }

    /**
     * タブを切り替えます。
     * @param {MouseEvent} event イベント。
     */
    _changeTab(event) {
        const targetTab = event.currentTarget;

        const self = this;
        Array.prototype.forEach.call(this._tabList, function (tab) {
            const isSelected = tab === targetTab;
            const tabLength = self._tabPanelList.length;
            let tabPanel;
            for (let i = 0; i < tabLength; i++) {
                const panel = self._tabPanelList[i];
                if (panel.id === tab.getAttribute('aria-controls')) {
                    tabPanel = panel;
                    break;
                }
            }

            tab.setAttribute('aria-selected', isSelected);
            tabPanel.setAttribute('aria-hidden', !isSelected);
        });
    }

    /**
     * マウスホイールイベントのイベントハンドラ。
     * @param {WheelEvent} event マウスホイールイベント。
     */
    _mouseWheelEventHandler(event) {

        const target = event.currentTarget;

        // deltaYが0でない場合(=上下のスクロール)の場合は横スクロールに置き換える。
        if (event.deltaY !== 0) {
            event.preventDefault();

            const deltaY = event.deltaY > 0 ? 1 : -1;
            const scrollVal = target.dataset.pageDirection === 'rtl' ? -1 * deltaY * 128 : deltaY * 128;

            if (HTMLUListElement.prototype.scrollBy) {
                target.scrollBy({
                    top: 0,
                    left: scrollVal,
                    behavior: 'auto',
                });
            }
            else {
                target.scrollLeft = target.scrollLeft - scrollVal;
            }
        }
    }

    /**
     * ボタンがマウスオーバーされた時のイベント。
     * hoverクラスの付与と（あれば）ツールチップの表示を行う。
     * @param {MouseEvent} event MouseEvent
     */
    _mouseOverEvent(event) {

        const element = event.currentTarget;
        element.classList.add('hover');
    }

    /**
     * ボタンがマウスオーバーされた時のイベント。
     * hoverクラスの除去と（あれば）ツールチップを非表示にする。
     * @param {MouseEvent} event MouseEvent
     */
    _mouseOutEvent(event) {

        const element = event.currentTarget;

        // hoverクラスの削除。
        element.classList.remove('hover');
        element.blur();
    }

    /**
     * 先頭のタブに遷移します。 
     */
    getCurrentTab() {
        let currentTab;
        Array.prototype.forEach.call(this._tabList, function (tab) {
            if (tab.getAttribute('aria-selected') === 'true') {
                currentTab = tab;
                return;
            };
        });
        return currentTab;
    }

    /**
     * 先頭のタブに遷移します。 
     */
    goToFirst() {
        this._tabList[0].click();
    }
}